import React, { Component } from 'react';
import { Container } from 'reactstrap';
import { connect } from 'react-redux';
import CreateClientAndPetForm from '../../forms/ClientAndPet';
import { createClientAndPet } from '../../services/Clients/actions';

class AddClientAndPet extends Component {
  onCreate = (values) => {
    this.props.createClientAndPet(values, () => {
      this.props.history.push(`/client/${this.props.Clients.createdClientId}`);
    });
  }

  render() {
    const initialValues = {
      clientState: 'Maharashtra',
      clientCity: 'Pune',
      petDob: new Date(),
    };
    const {
      Clients: {
        isLoading,
      },
    } = this.props;

    return (
      <Container className="pb-5">
        <CreateClientAndPetForm
          onSubmit={this.onCreate}
          isLoading={isLoading}
          submitLabel="Submit"
          showCancel={false}
          initialValues={initialValues}
        />
      </Container>
    );
  }
}

const mapStateToProps = state => ({
  Clients: state.Clients,
});

const mapDispatchToProps = {
  createClientAndPet,
};

export default connect(mapStateToProps, mapDispatchToProps)(AddClientAndPet);
